// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

type StatValue = {
  value: number | null;
  error?: string;
};

export class PartnerStatsEntity {
  static createFromAPI(partnerStats: {
    litigation: StatValue;
    in_business: StatValue;
    under_contract: StatValue;
    to_isolate: StatValue;
    unpaid_bills: StatValue;
  }): PartnerStatsEntity {
    try {
      if (!partnerStats || typeof partnerStats !== 'object') {
        throw new Error('Invalid data: data must be an object');
      }

      return new PartnerStatsEntity(partnerStats);
    } catch (error: any) {
      throw new Error(`Failed to create PartnerStatsEntity: ${error.message}`);
    }
  }

  litigation: StatValue;
  inBusiness: StatValue;
  underContract: StatValue;
  toIsolate: StatValue;
  unpaidBills: StatValue;

  private constructor(data: {
    litigation: StatValue;
    in_business: StatValue;
    under_contract: StatValue;
    to_isolate: StatValue;
    unpaid_bills: StatValue;
  }) {
    this.litigation = data.litigation;
    this.inBusiness = data.in_business;
    this.underContract = data.under_contract;
    this.toIsolate = data.to_isolate;
    this.unpaidBills = data.unpaid_bills;
  }

  get canClosePartner(): boolean {
    return (
      this.litigation.value === 0 &&
      this.inBusiness.value === 0 &&
      this.toIsolate.value === 0 &&
      this.unpaidBills.value === 0 &&
      !this.litigation.error &&
      !this.inBusiness.error &&
      !this.toIsolate.error &&
      !this.unpaidBills.error
    );
  }

  get cannotClosePartner(): boolean {
    return !this.canClosePartner;
  }
}
